import MainPage from './main';
import Edit from './edit';
import SingleChain from './singleChain';

const routes = [
    {
        path: '/*',
        Component: MainPage,
        props: {},
    },
    {
        path: '/:id/edit',
        Component: Edit,
        props: {},
    },
    {
        path: '/:id',
        Component: SingleChain,
        props: {},
    },
    {
        path: '/new',
        Component: Edit,
        props: {
            isNew: true,
        },
    },
];

export default routes;
